export const passwordValidationRules = (intl, newPassword) => {
  return [
    {
      id: 'minLength',
      description: intl.formatMessage({
        id: 'loginpage.resetpassword_newpassword.newpassword.rules.minlength',
        defaultMessage: 'Must contain between 8 and 25 characters',
      }),
      matchCondition: newPassword?.length >= 8 && newPassword?.length <= 25,
    },
    {
      id: 'lowercase',
      description: intl.formatMessage({
        id: 'loginpage.resetpassword_newpassword.newpassword.rules.lowercase',
        defaultMessage: 'At least one lowercase letter',
      }),
      matchCondition: !!newPassword && /[a-z]/.test(newPassword),
    },
    {
      id: 'uppercase',
      description: intl.formatMessage({
        id: 'loginpage.resetpassword_newpassword.newpassword.rules.uppercase',
        defaultMessage: 'At least one uppercase letter',
      }),
      matchCondition: !!newPassword && /[A-Z]/.test(newPassword),
    },
    {
      id: 'number',
      description: intl.formatMessage({
        id: 'loginpage.resetpassword_newpassword.newpassword.rules.number',
        defaultMessage: 'At least one digit',
      }),
      matchCondition: !!newPassword && /\d/.test(newPassword),
    },
    {
      id: 'specialCharacter',
      description: intl.formatMessage({
        id: 'loginpage.resetpassword_newpassword.newpassword.rules.specialcharacter',
        defaultMessage: 'At least one special character',
      }),
      matchCondition: !!newPassword && /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(newPassword),
    },
    {
      id: 'notWhitespace',
      description: intl.formatMessage({
        id: 'loginpage.resetpassword_newpassword.newpassword.rules.notwhitespace',
        defaultMessage: 'Must not contain any whitespaces',
      }),
      matchCondition: !!newPassword?.length && !/\s/.test(newPassword),
    },
  ];
};
